import { useEffect, useState } from 'react'
import close from '../../../assets/icons/close.svg';
import search from '../../../assets/icons/iconamoon_search-light.svg';
import imagePlaceholder from '../../../assets/Images/image 17.png';
import add from '../../../assets/icons/add.svg';
import deletered from '../../../assets/icons/deletered.svg';
import previous from '../../../assets/icons/previous.svg';
import next from '../../../assets/icons/icon.svg';
import savedraft from '../../../assets/icons/savedraft.svg';
import Select from 'react-select';
import { components } from 'react-select';
import { getData, patchData, Postdata, putData } from '../../../API/GlobalApi';
import { formatApiError } from '../../../Utils/apiErrors';
// import 'react-select/dist/react-select.css';

const CHANGE_TYPE_MESSAGES = {
  initial: 'Class assigned successfully',
  promotion: 'Student promoted successfully',
  section_transfer: 'Section transfer completed',
  course_change: 'Course changed successfully',
  manual_correction: 'Class updated successfully',
};

// Visual identity for each kind of LAG change, used by the history timeline.
// Hue choices: green=forward (promotion), indigo=lateral (section), amber=major
// (course change), slate=baseline (initial), rose=manual correction.
const CHANGE_TYPE_STYLE = {
  promotion: {
    label: 'Promotion',
    glyph: '↗',
    dot: '#047857',
    chipBg: '#ECFDF5',
    chipFg: '#065F46',
    chipBorder: '#A7F3D0',
  },
  section_transfer: {
    label: 'Section Transfer',
    glyph: '↔',
    dot: '#4338CA',
    chipBg: '#EEF2FF',
    chipFg: '#3730A3',
    chipBorder: '#C7D2FE',
  },
  course_change: {
    label: 'Course Change',
    glyph: '⤳',
    dot: '#B45309',
    chipBg: '#FFFBEB',
    chipFg: '#92400E',
    chipBorder: '#FDE68A',
  },
  initial: {
    label: 'Initial Assignment',
    glyph: '◉',
    dot: '#475569',
    chipBg: '#F1F5F9',
    chipFg: '#334155',
    chipBorder: '#CBD5E1',
  },
  manual_correction: {
    label: 'Manual Correction',
    glyph: '✎',
    dot: '#9F1239',
    chipBg: '#FFF1F2',
    chipFg: '#9F1239',
    chipBorder: '#FECDD3',
  },
};

const formatHistoryDate = (iso) => {
  if (!iso) return { day: '—', month: '', time: '' };
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { day: '—', month: '', time: '' };
  const day = String(d.getDate()).padStart(2, '0');
  const month = d.toLocaleString('en-US', { month: 'short' }).toUpperCase();
  const year = String(d.getFullYear()).slice(-2);
  const time = d.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return { day, month: `${month} ’${year}`, time };
};

const formatLag = (lag) => {
  if (!lag) return '—';
  const ag = lag.academic_group_name ? `${lag.academic_group_name} · ` : '';
  return `${lag.course_alias || ''} ${ag}${lag.name || ''}`.trim();
};

const LagHistoryTimeline = ({ entries, open, onToggle }) => {
  const count = Array.isArray(entries) ? entries.length : 0;

  return (
    <div className="row">
      <div className="col-md-12" style={{ marginTop: '14px' }}>
        <button
          type="button"
          onClick={onToggle}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 14px',
            background: open ? '#7F56DA' : '#FFFFFF',
            color: open ? '#FFFFFF' : '#7F56DA',
            border: '1px solid #7F56DA',
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'background 160ms ease, color 160ms ease',
            letterSpacing: '0.04em',
          }}
        >
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              fontSize: '12px',
              textTransform: 'uppercase',
              fontWeight: 700,
              fontVariant: 'small-caps',
            }}
          >
            <span
              aria-hidden
              style={{
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: open ? '#FFFFFF' : '#7F56DA',
                display: 'inline-block',
              }}
            />
            Movement History
            <span
              style={{
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                fontSize: '11px',
                opacity: 0.7,
                letterSpacing: '0.08em',
              }}
            >
              · {String(count).padStart(2, '0')}
            </span>
          </span>
          <span
            style={{
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
              fontSize: '11px',
              opacity: 0.85,
            }}
          >
            {open ? '— collapse' : '+ expand'}
          </span>
        </button>

        {open ? (
          count === 0 ? (
            <div
              style={{
                marginTop: '10px',
                padding: '24px 14px',
                border: '1px dashed #CBD5E1',
                borderRadius: '6px',
                textAlign: 'center',
                color: '#64748B',
                fontSize: '13px',
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                letterSpacing: '0.04em',
              }}
            >
              No movement on record.
            </div>
          ) : (
            <ol
              style={{
                listStyle: 'none',
                margin: '12px 0 0',
                padding: '4px 0 0 0',
                position: 'relative',
              }}
            >
              <span
                aria-hidden
                style={{
                  position: 'absolute',
                  left: '78px',
                  top: '8px',
                  bottom: '8px',
                  width: '1px',
                  background:
                    'linear-gradient(to bottom, transparent, #CBD5E1 12%, #CBD5E1 88%, transparent)',
                }}
              />
              {entries.map((e, idx) => {
                const style = CHANGE_TYPE_STYLE[e.change_type] || CHANGE_TYPE_STYLE.manual_correction;
                const date = formatHistoryDate(e.changed_on);
                return (
                  <li
                    key={e.id ?? idx}
                    style={{
                      position: 'relative',
                      display: 'grid',
                      gridTemplateColumns: '70px 24px 1fr',
                      columnGap: '8px',
                      padding: '10px 0',
                      animation: `lagHistoryFadeIn 240ms ease ${idx * 40}ms both`,
                    }}
                  >
                    {/* Date column — monospace small caps for an editorial feel */}
                    <div
                      style={{
                        textAlign: 'right',
                        fontFamily:
                          'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                        color: '#475569',
                        lineHeight: 1.2,
                      }}
                    >
                      <div style={{ fontSize: '20px', fontWeight: 600, color: '#0F172A', letterSpacing: '-0.02em' }}>
                        {date.day}
                      </div>
                      <div style={{ fontSize: '10px', letterSpacing: '0.1em', marginTop: '2px' }}>
                        {date.month}
                      </div>
                      <div style={{ fontSize: '10px', opacity: 0.7, marginTop: '2px' }}>
                        {date.time}
                      </div>
                    </div>

                    {/* Rail dot */}
                    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '6px' }}>
                      <span
                        aria-hidden
                        title={style.label}
                        style={{
                          position: 'relative',
                          width: '14px',
                          height: '14px',
                          borderRadius: '50%',
                          background: '#FFFFFF',
                          border: `2px solid ${style.dot}`,
                          boxShadow: `0 0 0 4px ${style.chipBg}`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '8px',
                          color: style.dot,
                        }}
                      />
                    </div>

                    {/* Event card */}
                    <div
                      style={{
                        background: '#FFFFFF',
                        border: '1px solid #E2E8F0',
                        borderLeft: `3px solid ${style.dot}`,
                        borderRadius: '4px',
                        padding: '10px 12px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          flexWrap: 'wrap',
                          marginBottom: '6px',
                        }}
                      >
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            background: style.chipBg,
                            color: style.chipFg,
                            border: `1px solid ${style.chipBorder}`,
                            padding: '2px 8px',
                            borderRadius: '999px',
                            fontSize: '11px',
                            fontWeight: 600,
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                          }}
                        >
                          <span aria-hidden style={{ fontSize: '12px', lineHeight: 1 }}>
                            {style.glyph}
                          </span>
                          {style.label}
                        </span>
                        {e.changed_by ? (
                          <span
                            style={{
                              fontSize: '11px',
                              color: '#64748B',
                              fontFamily:
                                'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                            }}
                          >
                            by {e.changed_by}
                          </span>
                        ) : null}
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          flexWrap: 'wrap',
                          fontSize: '13px',
                          color: '#0F172A',
                        }}
                      >
                        <span style={{ color: '#94A3B8' }}>{formatLag(e.from_lag)}</span>
                        <span
                          aria-hidden
                          style={{
                            color: style.dot,
                            fontWeight: 700,
                            letterSpacing: '0.05em',
                          }}
                        >
                          ──▶
                        </span>
                        <span style={{ fontWeight: 600 }}>{formatLag(e.to_lag)}</span>
                      </div>

                      {e.notes ? (
                        <div
                          style={{
                            marginTop: '8px',
                            padding: '6px 8px',
                            background: '#F8FAFC',
                            borderLeft: '2px solid #CBD5E1',
                            fontSize: '12px',
                            color: '#475569',
                            fontStyle: 'italic',
                          }}
                        >
                          “{e.notes}”
                        </div>
                      ) : null}
                    </div>
                  </li>
                );
              })}
              <style>{`
                @keyframes lagHistoryFadeIn {
                  from { opacity: 0; transform: translateY(4px); }
                  to   { opacity: 1; transform: translateY(0); }
                }
              `}</style>
            </ol>
          )
        ) : null}
      </div>
    </div>
  );
};


export const OfficialInformation = ({ onClose, currentStep, setCurrentStep, handlePrev, handleNext, steps, setsubmit, studentid, officialdata, selectedUserId, mainnamehead, setgeneratedregno, registrationnumforhead, regMode, isLoadingFormDetails, fetchStudents, currentPage }) => {

  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [org, setorg] = useState([]);
  const [coursedata, setcoursedata] = useState([]);
  const [classdata, setclassdata] = useState([]);
  const [courseid, setcourseid] = useState(null);
  const [classid, setclassid] = useState(null);
  const [academicgroupid, setacademicgroupid] = useState(null);
  const [academicgroupdata, setacademicgroupdata] = useState([]);
  const [orgid, setorgid] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastVariant, setToastVariant] = useState('success');
  const [toastMessage, setToastMessage] = useState('');
  const [confirmreg, setconfirmreg] = useState(false);
  const studentId = studentid || sessionStorage.getItem('studentid');
  const [prnYearMismatch, setPrnYearMismatch] = useState(null);
  const [permanentRegistrationNumber, setPermanentRegistrationNumber] = useState('');
  const [reconcileChoice, setReconcileChoice] = useState('use_prn_year');
  const [reconcileBusy, setReconcileBusy] = useState(false);
  const [hasExistingPlacement, setHasExistingPlacement] = useState(true);
  // In regMode, only lock Institution + Course once admission is finalized
  // (i.e. a PRN exists). When the student is still in provisional state with
  // no PRN, allow correcting the original placement — otherwise an admin can't
  // fix a wrong provisional admission without opening it in edit mode.
  const lockCourseFields = regMode && hasExistingPlacement && Boolean(permanentRegistrationNumber);
  const [academicYearId, setAcademicYearId] = useState(null);
  // Per-LAG draft intake values keyed by lag id; lets the user edit the
  // intake_limit inline without leaving this modal when a class shows 0/None.
  const [intakeDrafts, setIntakeDrafts] = useState({});
  const [intakeSavingId, setIntakeSavingId] = useState(null);
  const [lagHistory, setLagHistory] = useState([]);
  const [historyOpen, setHistoryOpen] = useState(false);
  // Snapshot of the LAG id at the time the modal loaded; used to gate Submit
  // so the user can't trigger a no-op PATCH (which the backend would reject as
  // "Student is already in this LAG").
  const [initialClassId, setInitialClassId] = useState(null);
  const displayToast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);

    setTimeout(() => setShowToast(false), 3000);
  };

  const getorgdata = async () => {
    const url = "administration/organizations/";
    const response = await getData(url);
    if (response && Array.isArray(response)) {
      setorg(response);
    } else {
      setorg([]);
    }
  }
  const handleChange = (selectedOptions) => {
    setSelectedSubjects(selectedOptions);
  };
  const getcourselist = async () => {

    let url = `students/get-course-list-by-organization/?organization_id=${orgid}`;
    let res = await getData(url);
    if (res && Array.isArray(res)) {
      setcoursedata(res);
    } else {
      setcoursedata([]);
    }
  }
  const getspclist = async () => {
    let url = `students/get-academic-group-list-by-specialization/?specialization_id=${courseid}`;
    let res = await getData(url);
    if (res && Array.isArray(res)) {
      setclassdata(res);
    } else {
      setclassdata([]);
    }
  }
  const handleChangenest = async (e) => {
    const { name, value } = e.target;
    if (name === "org") {
      setorgid(value);
      if (value) {
        let url = `students/get-course-list-by-organization/?organization_id=${value}`;
        let res = await getData(url);
        if (res && Array.isArray(res)) {
          setcoursedata(res);
        } else {
          setcoursedata([]);
        }
      }
    }

    if (name === 'course_name') {
      setcourseid(value)
      let url = `students/get-academic-groups-by-specialization/?specialization_id=${value}`;
      let res = await getData(url);
      if (res && Array.isArray(res)) {
        setacademicgroupdata(res);
      } else {
        setacademicgroupdata([]);
      }
    }
    if (name === 'academicgroup') {
      setacademicgroupid(value)
      let url = `students/get-least-academic-groups-by-academic-group/?academic_group_id=${value}`;
      if (academicYearId) url += `&academic_year_id=${academicYearId}`;
      let res = await getData(url);
      if (res && Array.isArray(res)) {
        setclassdata(res);
      } else {
        setclassdata([]);
      }
    }
    if (name === 'class') {
      setclassid(value)

    }
  }

  const clearsessiondata = () => {
    sessionStorage.removeItem('studentBasicForm');
    sessionStorage.removeItem('studentBasicFormMobileNumber');
    sessionStorage.removeItem('studentBasicFormAddress');
    sessionStorage.removeItem('studentid');
    sessionStorage.removeItem('topphoneNumber');
    sessionStorage.removeItem('otpverified');
    sessionStorage.removeItem('profilepic');

    // Store dropdown-related states after setting them



    // Also store dropdowns if already available
    sessionStorage.removeItem('studentPrivilegeCategories');
    sessionStorage.removeItem('studentCategories');
    sessionStorage.removeItem('salutations');
    sessionStorage.removeItem('genders');
    sessionStorage.removeItem('bloodGroups');
    sessionStorage.removeItem('contactNumberTypes');
    // sessionStorage.setItem('addressTypes', JSON.stringify(addressTypes));
    sessionStorage.removeItem('courses');

    sessionStorage.removeItem('correspondenceCountry');
    sessionStorage.removeItem('permanentCountry');
    sessionStorage.removeItem('correspondenceState');
    sessionStorage.removeItem('permanentState');
    sessionStorage.removeItem('correspondenceCity');
    sessionStorage.removeItem('permanentCity');
  }
  const handleReconcilePrnYear = async () => {
    setReconcileBusy(true);
    try {
      const url = `students/student-onboarding-official-details/${studentId || selectedUserId}/reconcile-prn-year/`;
      const res = await Postdata(url, { action: reconcileChoice });
      if (res?.error) {
        displayToast(formatApiError(res, 'PRN reconciliation failed'), 'danger');
        return;
      }
      if (res?.permanent_registration_number !== undefined) {
        setPermanentRegistrationNumber(res.permanent_registration_number || '');
        setPrnYearMismatch({
          ...(prnYearMismatch || {}),
          mismatch: false,
          prn_year: null,
          academic_year_year: null,
          academic_year_name: res.academic_year ? res.academic_year.name : null,
        });
        if (typeof setgeneratedregno === 'function') {
          setgeneratedregno(res.permanent_registration_number);
        }
        displayToast('PRN year reconciled successfully', 'success');
        const refresh = await getData(`students/get-student-onboarding-official-details/${studentId || selectedUserId}/`);
        if (refresh) {
          setPrnYearMismatch(refresh.prn_year_mismatch || null);
          setPermanentRegistrationNumber(refresh.permanent_registration_number || '');
        }
      } else {
        displayToast('Something went wrong', 'danger');
      }
    } finally {
      setReconcileBusy(false);
    }
  };

  const refreshClassData = async () => {
    if (!academicgroupid) return;
    let url = `students/get-least-academic-groups-by-academic-group/?academic_group_id=${academicgroupid}`;
    if (academicYearId) url += `&academic_year_id=${academicYearId}`;
    const resp = await getData(url);
    setclassdata(Array.isArray(resp) ? resp : []);
  };

  const handleIntakeDraftChange = (lagId, value) => {
    setIntakeDrafts((prev) => ({ ...prev, [lagId]: value }));
  };

  const handleSaveIntakeLimit = async (lag) => {
    const raw = intakeDrafts[lag.id];
    const parsed = parseInt(raw, 10);
    if (Number.isNaN(parsed) || parsed <= 0 || parsed > 1000) {
      displayToast('Intake limit must be a positive integer between 1 and 1000.', 'danger');
      return;
    }
    setIntakeSavingId(lag.id);
    try {
      const res = await putData(`academics/least-academic-group/${lag.id}/`, {
        academic_group_id: lag.academic_group,
        name: lag.name,
        intake_limit: parsed,
      });
      // Success: serializer echoes the saved row, including a numeric `id`.
      // Field errors come back as { intake_limit: ["..."], ... } — arrays — or
      // { error: ... } / { detail: ... } / { non_field_errors: [...] }.
      const isFieldError =
        !res ||
        res.error !== undefined ||
        res.detail !== undefined ||
        Array.isArray(res.non_field_errors) ||
        Array.isArray(res.intake_limit) ||
        Array.isArray(res.name) ||
        Array.isArray(res.academic_group_id) ||
        typeof res.id !== 'number';
      if (isFieldError) {
        displayToast(formatApiError(res, 'Failed to update intake limit'), 'danger');
        return;
      }
      displayToast(`Intake limit for ${lag.name} updated to ${parsed}.`, 'success');
      setIntakeDrafts((prev) => {
        const next = { ...prev };
        delete next[lag.id];
        return next;
      });
      await refreshClassData();
    } finally {
      setIntakeSavingId(null);
    }
  };

  // Close paths (X button, footer Close button) — just close without triggering
  // the "Details Updated Successfully" popup. That popup is only shown after a
  // real successful submit (handled inside handleSubmit).
  const closeWithPopup = () => {
    setCurrentStep(0);
    clearsessiondata();
    onClose();
  };

  // Submit is gated to prevent the no-op PATCH that would otherwise return
  // "Student is already in this LAG.". In regMode the user is creating, so
  // any selected class is fair to submit; in edit mode we require an actual
  // change from the initially-loaded class.
  const submitDisabled = regMode
    ? !classid
    : !classid || classid === initialClassId;

  const handleSubmit = async () => {
    const missingFields = [];
    if (!orgid) missingFields.push('Institution Name');
    if (!courseid) missingFields.push('Course Name');
    if (!academicgroupid) missingFields.push('Academic Group');
    if (!classid) missingFields.push('Class');

    if (missingFields.length) {
      displayToast(`Please select: ${missingFields.join(', ')}`, 'danger');
      return;
    }


    const finalobj = {
      lag: classid
    };

    const url = `students/student-onboarding-official-details/${studentId || selectedUserId}/`;
    const res = await patchData(url, finalobj);


    // ✅ Check for error first
    if (res?.error) {
      displayToast(formatApiError(res, 'Update failed'), 'danger');
      return; // STOP execution here
    }

    if (res) {
      setgeneratedregno(res.permanent_registration_number);

      if (selectedUserId) {
        setsubmit(true);
      }

      const successMessage =
        CHANGE_TYPE_MESSAGES[res.change_type] || 'Official Information submitted successfully';
      displayToast(successMessage, 'success');
      await new Promise(resolve => setTimeout(resolve, 200));
      setCurrentStep(0);
      clearsessiondata()
      fetchStudents({ page: currentPage })
      onClose();
    } else {

      displayToast('Something went wrong', 'danger');
    }
  };


  const CustomValueContainer = ({ children, ...props }) => {
    return <components.ValueContainer {...props}>{null}</components.ValueContainer>;
  };

  useEffect(() => {
    getorgdata()
  }, [])

  useEffect(() => {
    const fetchOfficialData = async () => {
      const url = `students/get-student-onboarding-official-details/${studentId || selectedUserId}/`;
      const res = await getData(url);

      if (res) {
        // Hydrate from `lag` (current placement) first; fall back to
        // `provisional_academic_group` only when `lag` is null (the student
        // is still in pre-provisional-admission state). After a course
        // change, provisional_academic_group keeps its original value, so
        // pulling org/course from it would render a stale Institution and
        // Course Name that no longer match the current AG/LAG.
        const orgId = res?.lag?.academic_group?.specialization?.course?.organization?.id
          || res?.provisional_academic_group?.specialization?.course?.organization?.id
          || null;
        const courseId = res?.lag?.academic_group?.specialization?.id
          || res?.provisional_academic_group?.specialization?.id
          || null;
        const academicGroupId = res?.lag?.academic_group?.id
          || res?.provisional_academic_group?.id
          || null;
        const classId = res?.lag?.id || null;

        setorgid(orgId);
        setcourseid(courseId);
        setacademicgroupid(academicGroupId);
        setclassid(classId)
        setInitialClassId(classId);
        setPrnYearMismatch(res.prn_year_mismatch || null);
        setPermanentRegistrationNumber(res.permanent_registration_number || '');
        setHasExistingPlacement(Boolean(res?.provisional_academic_group || res?.lag));
        setAcademicYearId(res?.academic_year?.id || null);
        setLagHistory(Array.isArray(res?.lag_history) ? res.lag_history : []);

        if (orgId) {
          const courses = await getData(`students/get-course-list-by-organization/?organization_id=${orgId}`);
          setcoursedata(Array.isArray(courses) ? courses : []);
        } else {
          setcoursedata([]);
        }

        if (courseId) {
          const academicgrp = await getData(`students/get-academic-groups-by-specialization/?specialization_id=${courseId}`);
          setacademicgroupdata(Array.isArray(academicgrp) ? academicgrp : []);
        } else {
          setacademicgroupdata([]);
        }

        if (academicGroupId) {
          const acadYearForLagFetch = res?.academic_year?.id || null;
          let lagUrl = `students/get-least-academic-groups-by-academic-group/?academic_group_id=${academicGroupId}`;
          if (acadYearForLagFetch) lagUrl += `&academic_year_id=${acadYearForLagFetch}`;
          const resp = await getData(lagUrl);
          setclassdata(Array.isArray(resp) ? resp : []);
        } else {
          setclassdata([]);
        }
      }
    };

    fetchOfficialData();
  }, [currentStep]);


  return (
    <>

      {isLoadingFormDetails ? (
        <div className="text-center"
          style={{
            height: "77vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            color: "#7F56DA",
          }}
        >
          <div
            className="spinner-border"
            role="status"
            style={{ color: '#7F56DA', width: '3rem', height: '3rem' }}
          />
          <p className="mt-2">Loading student details...</p>
        </div>

      ) : (
        <>

          <div className="col-md-10" style={{ height: "77vh", overflowY: 'scroll' }}>
            <div style={{ position: 'sticky', top: 0, background: "#fff" }}>
              <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h2 className='text-primary'>{mainnamehead} {registrationnumforhead ? `(${registrationnumforhead})` : ''}</h2>
                <button className="close-btn" onClick={closeWithPopup}><img src={close} style={{ padding: "4px", background: '#F2F3F4', borderRadius: '50%' }}></img></button>
              </div>
            </div>
            {regMode && !hasExistingPlacement ? (
              <div
                style={{
                  background: '#E7F0FF',
                  border: '1px solid #91B6F2',
                  borderRadius: '6px',
                  padding: '10px 14px',
                  margin: '8px 0 14px 0',
                  fontSize: '14px',
                  color: '#1F3A6E',
                }}
              >
                No provisional academic group on record for this student — please select Institution and Course.
              </div>
            ) : null}
            {prnYearMismatch && prnYearMismatch.mismatch ? (
              <div
                style={{
                  background: '#FFF7E6',
                  border: '1px solid #FFC069',
                  borderLeft: '4px solid #7F56DA',
                  borderRadius: '6px',
                  padding: '12px 14px',
                  margin: '8px 0 14px 0',
                }}
              >
                <div style={{ fontWeight: 600, color: '#874D00', marginBottom: '6px' }}>
                  Year mismatch between PRN and Academic Year
                </div>
                <div style={{ fontSize: '14px', marginBottom: '10px' }}>
                  PRN <strong>{permanentRegistrationNumber}</strong> contains year{' '}
                  <strong>{prnYearMismatch.prn_year}</strong>, but the student's Academic Year is{' '}
                  <strong>{prnYearMismatch.academic_year_name || prnYearMismatch.academic_year_year}</strong>.
                  Choose how to reconcile:
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '10px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                    <input
                      type="radio"
                      name="reconcileChoice"
                      value="use_prn_year"
                      checked={reconcileChoice === 'use_prn_year'}
                      onChange={(e) => setReconcileChoice(e.target.value)}
                    />
                    Change Academic Year to match PRN ({prnYearMismatch.prn_year}-{(prnYearMismatch.prn_year || 0) + 1})
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                    <input
                      type="radio"
                      name="reconcileChoice"
                      value="use_academic_year"
                      checked={reconcileChoice === 'use_academic_year'}
                      onChange={(e) => setReconcileChoice(e.target.value)}
                    />
                    Rewrite PRN's year segment to {prnYearMismatch.academic_year_year}
                  </label>
                </div>
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={handleReconcilePrnYear}
                  disabled={reconcileBusy}
                  style={{ padding: '6px 16px' }}
                >
                  {reconcileBusy ? 'Applying...' : 'Apply'}
                </button>
              </div>
            ) : null}
            <div className="row" >
              <div className="col-md-6">
                <label className='form-labell'>Institution Name</label><span className='astrisk'>*</span>
                <select className='fm-modal form-control form-select' onChange={handleChangenest} name='org' value={orgid} disabled={lockCourseFields}>
                  <option value=''>Select Institution Name</option>
                  {org && Array.isArray(org) && org?.map((val, ind) => {

                    return (<>
                      <option key={ind} value={val.id}
                      >{val.name}</option>
                    </>
                    )
                  })}
                </select>
              </div>

              <div className="col-md-6">
                <label className='form-labell'>Course Name</label><span className='astrisk'>*</span>
                <select className='fm-modal form-control form-select' onChange={handleChangenest} name='course_name' value={courseid} disabled={lockCourseFields}>
                  <option value=''>Select Course Name</option>
                  {coursedata && Array.isArray(coursedata) && coursedata?.map((val, ind) => {

                    return (<>
                      <option key={ind} value={val?.id}
                      >{val.course_specialization}</option>
                    </>
                    )
                  })}
                </select>
              </div>

            </div>
            <div className="row" >

              <div className="col-md-6">
                <label className='form-labell'>Academic Group</label><span className='astrisk'>*</span>
                <select className='fm-modal form-control form-select' onChange={handleChangenest} name='academicgroup' value={academicgroupid} >
                  <option value=''>Select Academic Group </option>
                  {academicgroupdata && Array.isArray(academicgroupdata) && academicgroupdata?.map((val, ind) => {

                    return (<>
                      <option key={ind} value={val.id}
                      >{val.name}</option>
                    </>
                    )
                  })}
                </select>
              </div>
              <div className="col-md-6">
                <label className='form-labell'>Class</label><span className='astrisk'>*</span>
                <select className='fm-modal form-control form-select' onChange={handleChangenest} name='class' value={classid} >
                  <option value=''>Select Class </option>
                  {classdata && Array.isArray(classdata) && classdata?.map((val, ind) => {

                    return (<>
                      <option key={ind} value={val.id} disabled={val.is_limit_full}
                      >{val?.name} ({val.registered_students}/{val.intake_limit}) {val.is_limit_full ? 'Intake Capacity Reached' : ''}</option>
                    </>
                    )
                  })}
                </select>
              </div>
            </div>
            {academicgroupid && Array.isArray(classdata) && classdata.length > 0 ? (
              <div className="row">
                <div className="col-md-12" style={{ marginTop: '12px' }}>
                  <div
                    style={{
                      border: '1px solid #E5E7EB',
                      borderLeft: '4px solid #7F56DA',
                      borderRadius: '6px',
                      padding: '10px 14px',
                      background: '#FAFAFA',
                    }}
                  >
                    <div style={{ fontWeight: 600, marginBottom: '8px', fontSize: '14px' }}>
                      Manage seat capacity
                    </div>
                    <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '8px' }}>
                      A class with intake limit 0 cannot accept students. Set a positive limit (1–1000) to enable it.
                    </div>
                    {classdata.map((lag) => {
                      const draftValue = intakeDrafts[lag.id];
                      const currentDisplay = lag.intake_limit || 0;
                      return (
                        <div
                          key={lag.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '6px 0',
                            borderTop: '1px solid #F0F0F0',
                          }}
                        >
                          <div style={{ flex: '1 1 auto', fontSize: '14px' }}>
                            {lag.name}
                            <span style={{ color: '#6B7280', marginLeft: '6px', fontSize: '12px' }}>
                              ({lag.registered_students}/{currentDisplay})
                            </span>
                          </div>
                          <input
                            type="number"
                            min="1"
                            max="1000"
                            placeholder={String(currentDisplay)}
                            value={draftValue ?? ''}
                            onChange={(e) => handleIntakeDraftChange(lag.id, e.target.value)}
                            style={{
                              width: '100px',
                              padding: '4px 8px',
                              border: '1px solid #D1D5DB',
                              borderRadius: '4px',
                              fontSize: '14px',
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleSaveIntakeLimit(lag)}
                            disabled={
                              intakeSavingId === lag.id ||
                              draftValue === undefined ||
                              draftValue === ''
                            }
                            style={{ padding: '4px 12px', fontSize: '13px' }}
                          >
                            {intakeSavingId === lag.id ? 'Saving…' : 'Save'}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ) : null}
            <LagHistoryTimeline
              entries={lagHistory}
              open={historyOpen}
              onToggle={() => setHistoryOpen((v) => !v)}
            />
            {/* <div className="row">
            <div className="col-md-6">
              <label className='form-labell'>Subjects Taken<span className='astrisk'>*</span></label>
              <Select
                id='Subjects'
                isMulti
                name="subjects"
                options={options}
                value={selectedSubjects}
                onChange={handleChange}
                closeMenuOnSelect={false}
                // components={{ MultiValueRemove: customRemoveIcon }}
                placeholder="Select Subjects"
                // hideSelectedOptions={true}
                components={{
                  ValueContainer: CustomValueContainer, // Prevent rendering of selected tags inside the input
                }}

              />
              <div className="selected-tags mt-3">
                {selectedSubjects.map((subject, index) => (
                  <span key={index} className="tag">
                    {subject.label}
                    <span
                      className="remove-tag"
                      onClick={() => {
                        setSelectedSubjects(
                          selectedSubjects.filter((item) => item.value !== subject.value)
                        );
                      }}
                    >
                      &times;
                    </span>
                  </span>
                ))}
              </div>
            </div>
          </div> */}
          </div>
          <div className="form-actions" style={{ position: 'sticky', background: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: "flex", gap: '20px' }}>
              <button
                type="button"
                onClick={() => { handlePrev() }}
                disabled={currentStep === 0}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '6px 18px',
                  background: '#FFFFFF',
                  color: '#0F172A',
                  border: '1px solid #CBD5E1',
                  borderRadius: '6px',
                }}
              >
                <img src={previous} alt="" />Previous
              </button>
            </div>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <button
                type="button"
                onClick={closeWithPopup}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '6px 18px',
                  background: '#FFFFFF',
                  color: '#0F172A',
                  border: '1px solid #CBD5E1',
                  borderRadius: '6px',
                }}
              >
                Close
              </button>
              {regMode ?
                <button
                  type="button"
                  disabled={submitDisabled}
                  onClick={() => setconfirmreg(true)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '6px 18px',
                    background: submitDisabled ? '#C4B5FD' : '#7F56DA',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: submitDisabled ? 'not-allowed' : 'pointer',
                  }}
                >Submit</button> :
                <button
                  type="button"
                  disabled={submitDisabled}
                  onClick={async () => {
                    const success = await handleSubmit();
                    if (success) {
                      handleNext();
                    }
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '6px 18px',
                    background: submitDisabled ? '#C4B5FD' : '#7F56DA',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: submitDisabled ? 'not-allowed' : 'pointer',
                  }}
                >Submit</button>}
            </div>
          </div>
        </>
      )}
      {showToast && (
        <div
          className={`custom-toast toast align-items-center text-white bg-${toastVariant} border-0 position-fixed top-0 end-0 m-3`}
          role="alert"
          style={{
            display: 'block',
            minWidth: '300px',
            maxWidth: '400px',
            borderRadius: '8px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
            fontSize: '15px',
            zIndex: 9999
          }}
        >
          <div className="d-flex">
            <div className="toast-body" style={{ padding: '12px 16px' }}>
              <strong>{toastVariant === 'success' ? '✅' : '❌'} </strong> {toastMessage}
            </div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
              aria-label="Close"
            ></button>
          </div>
        </div>



      )}
      {confirmreg && regMode ? <div className="modal-overlay">
        <div className="modal-content mc-cus" >
          {/* <h3>Admission Confirmed</h3> */}
          <p style={{ fontSize: '16px' }}>
            Do you want to confirm the admission?
          </p>
          <div style={{ display: 'flex', justifyContent: 'end', gap: '5px', marginTop: '20px' }}>
            <button type="btn" style={{ display: 'flex', alignItems: 'center', gap: "10px" }}
              onClick={() => setconfirmreg(false)}
            >No</button>
            <button type="btn" style={{ display: 'flex', alignItems: 'center', gap: "10px" }}
              onClick={async () => {
                // handleNext(); handleSubmit()
                const success = await handleSubmit();  // ✅ first await submission
                if (success) {
                  handleNext();  // ✅ only move next if form successfully submitted
                }
              }}
            // onClick={() => setconfirmreg(true)}
            >Yes</button>
          </div>
        </div>
      </div> : ''}

    </>
  )
}
